const types = {
    SWITCH_STATISTICAL: 'SWITCH_STATISTICAL',
};

export const actions = {
    switchStatistical: (settlementType) => ({
        type: types.SWITCH_STATISTICAL,
        settlementType,
    })
};

const initState = {
    settlementType: 'BILLING_MONTH',
};

export default function(state = initState, action) {
    const { type, settlementType } = action;
    switch(type) {
        case types.SWITCH_STATISTICAL:
            return {
                settlementType,
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/actions/inProjectActions.js